import useDataObjectTransform from "./useDataObjectTransform"
import { SolrQueryBuilder } from "../services/solr/SolrQueryBuilder"
import { SolrApi } from "../services/solrApi"
import solrConfig from "../config/solr.json"

const queryConfig = solrConfig.query
const clientConfig = solrConfig.server
const solrClient = new SolrApi(clientConfig)

const useSearchForm = () => {
  const {
    globalSearchDataFilterAndtransform,
    autocompleteDataTransform,
    globalSearchFiltersTransform,
  } = useDataObjectTransform()

  const submitSearchForm = (value, redirect) => {
    if (redirect) {
      window.location.href = window.location.origin + "/search/?keyword=" + value
    } else {
      window.history.pushState({}, "Search", window.location.origin + "/search/?keyword=" + value)
    }
  }

  const isOneWord = (str) => {
    const words = str.trim().split(/\s+/)
    return words.length === 1
  }

  const getAutocompleteResults = async (keyword) => {
    const formattedKeyword = isOneWord(keyword) ? `${keyword}*` : `'${keyword}'*`
    const solrQuery = new SolrQueryBuilder({ ...queryConfig, isGlobalIndex: true })
    solrQuery
      .q({
        tcngramstringm_X3b_en_gw_concat_searchable_fields: formattedKeyword,
        tcngramstringm_X3b_en_node_title: formattedKeyword,
      })
      .fq([{ field: "index_id", value: "global_index_autocomplete" }])
      .sort({ boost_document: "desc" })
      .rows(6)
    const response = await solrClient.runQuery(solrQuery)
    const solrRecords = response?.response?.docs || []
    const results = autocompleteDataTransform(solrRecords)
    return results || []
  }

  const getSearchResults = async (keyword, startIndex = 0, filter = null) => {
    const solrQuery = new SolrQueryBuilder({ ...queryConfig, isGlobalIndex: true })
    const formattedFilter =
      filter === "travel_guide" || filter === "article" ? ["travel_guide", "article"] : filter
    solrQuery
      .q({
        tcngramstringm_X3b_en_node_title: `"${keyword}*"`,
        tcngramstringm_X3b_en_gw_concat_searchable_fields: `"${keyword}*"`,
        sort_X3b_en_url: `${keyword}*`,
        tcngramstringm_X3b_en_node_overview_description: `${keyword}*`,
      })
      .df("tcngramstringm_X3b_en_node_title")
      .fq([
        { field: "index_id", value: "global_index" },
        ...(formattedFilter ? [{ field: "ss_node_type", value: formattedFilter }] : []),
      ])
      .facet({
        field: "ss_node_type",
      })
      .sort({ score: "desc" })
      .start(startIndex)
      .rows(14)
    const response = await solrClient.runQuery(solrQuery)
    const solrRecords = response?.response?.docs || []
    const totalResults = response?.response?.numFound || 0
    const filters =
      globalSearchFiltersTransform(
        response?.facet_counts?.facet_fields?.ss_node_type,
        totalResults
      ) || []
    return {
      filters,
      totalResults,
      pages: totalResults ? Math.ceil(totalResults / 14) : 0,
      results: globalSearchDataFilterAndtransform(solrRecords)?.slice(0, 14) || [],
    }
  }

  return {
    submitSearchForm,
    getSearchResults,
    getAutocompleteResults,
  }
}

export default useSearchForm
